
import { defineComponent } from 'vue'

/**
 * Invite members success modal
 */
export default defineComponent({
  name: 'InviteMembersSuccessModal',
  emits: ['close', 'invite-more']
})
